/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';

import {
  Grid,
  Box,
  Button,
  Autocomplete,
  TextField,
  Card,
  CardContent,
  Divider,
  Typography,
} from '@mui/material';
import { PDFDownloadLink } from '@react-pdf/renderer';
import NumberFormat from '../../utils/NumberFormat';
import { ContainerPainel, Title, SubTitle } from '../../styles/GlobalStyles';
import Loading from '../../components/Loading';
import axios from '../../services/axios';
import * as colors from '../../config/colors';
import { roundToTwoDecimal } from '../../utils/numberUtils';
import PDFContent from './PDFContent';

dayjs.locale('pt-br'); // ajuste o caminho conforme necessário

export default function DashDre() {
  const [motoristas, setMotoristas] = useState([]);
  const [veiculos, setVeiculos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [viagens, setViagens] = useState([]);
  const [dtinicial, setDtInicial] = useState(null);
  const [dtfinal, setDtFinal] = useState(null);

  const [id_motorista, setIdMotorista] = useState(null);
  const [id_veiculo, setIdVeiculo] = useState(null);
  const [id_empresa, setIdEmpresa] = useState(null);
  const [id_cliente, setIdCliente] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    async function fetchMotoristas() {
      const response = await axios.get('/motoristas');
      setMotoristas(response.data);
    }
    async function fetchVeiculos() {
      const response = await axios.get('/veiculos');
      setVeiculos(response.data);
    }
    async function fetchEmpresas() {
      const response = await axios.get('/empresas');
      setEmpresas(response.data);
    }
    async function fetchClientes() {
      const response = await axios.get('/clientes');
      setClientes(response.data);
    }
    fetchMotoristas();
    fetchVeiculos();
    fetchEmpresas();
    fetchClientes();
    setIsLoading(false);
  }, []);

  async function fetchAll() {
    const params = {};
    let formErrors = true;

    if (id_empresa) {
      params.id_empresa = id_empresa;
    }
    if (id_motorista) {
      params.id_motorista = id_motorista;
    }
    if (id_veiculo) {
      params.id_veiculo = id_veiculo;
    }
    if (id_cliente) {
      params.id_cliente = id_cliente;
    }
    if (dtinicial) {
      params.dtinicial = dtinicial;
    } else {
      toast.error('Informe a Data Inicial');
      formErrors = false;
    }
    if (dtfinal) {
      params.dtfinal = dtfinal;
    } else {
      toast.error('Informe a Data Final');
      formErrors = false;
    }

    if (formErrors) {
      const response = await axios.get('/viagens/dashDre', { params });
      const viagensData = response.data;
      setViagens(viagensData);
    }
  }

  function limparFiltros() {
    setDtInicial(null);
    setDtFinal(null);
    setIdMotorista(null);
    setIdEmpresa(null);
    setIdCliente(null);
    setIdVeiculo(null);
    setViagens([]);
  }

  const totalizador = viagens.reduce(
    (acc, viagem) => {
      acc.receitas += viagem.total_receitas || 0;
      acc.despesas += viagem.total_despesas || 0;
      acc.comissao += viagem.total_comissao || 0;
      acc.lucro += viagem.lucro || 0;
      acc.lucrobruto = roundToTwoDecimal(
        ((acc.total_receitas - acc.total_despesas) /
          (acc.total_receitas || 1)) *
          100
      );
      acc.consumo_receita += viagem.consumo_receita || 0;
      acc.despesa_receita += viagem.despesa_receita || 0;
      return acc;
    },
    {
      receitas: 0,
      despesas: 0,
      comissao: 0,
      lucro: 0,
      lucrobruto: 0,
    }
  );

  return (
    <ContainerPainel>
      <Loading isLoading={isLoading} />
      <Title>DRE</Title>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <DatePicker
                required
                label="Data Inicial"
                size="small"
                value={dtinicial}
                onChange={(date) => setDtInicial(date)}
                format="DD/MM/YYYY"
                inputFormat="DD/MM/YYYY"
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <DatePicker
                required
                label="Data Final"
                size="small"
                value={dtfinal}
                onChange={(date) => setDtFinal(date)}
                format="DD/MM/YYYY"
                inputFormat="DD/MM/YYYY"
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id={id_motorista ? String(id_motorista) : ''}
              value={
                motoristas.find((option) => option.id === id_motorista) || null
              }
              options={motoristas}
              getOptionLabel={(option) => option.nome}
              onChange={(event, newValue) => {
                setIdMotorista(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Motorista"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id={id_veiculo ? String(id_veiculo) : ''}
              value={
                veiculos.find((option) => option.id === id_veiculo) || null
              }
              options={veiculos}
              getOptionLabel={(option) => option.placa}
              onChange={(event, newValue) => {
                setIdVeiculo(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Veículo"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id={id_empresa ? String(id_empresa) : ''}
              value={
                empresas.find((option) => option.id === id_empresa) || null
              }
              options={empresas}
              getOptionLabel={(option) => option.nome}
              onChange={(event, newValue) => {
                setIdEmpresa(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Empresa"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id={id_cliente ? String(id_cliente) : ''}
              value={
                clientes.find((option) => option.id === id_cliente) || null
              }
              options={clientes}
              getOptionLabel={(option) => option.nome}
              onChange={(event, newValue) => {
                setIdCliente(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Cliente"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => fetchAll()}
              style={{ marginRight: '10px' }}
            >
              Filtrar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => limparFiltros()}
            >
              Limpar Filtros
            </Button>
          </Grid>
        </Grid>
      </Box>

      <SubTitle
        style={{
          background: colors.cardColor4,
        }}
      >
        Resumo por Veículo
      </SubTitle>

      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
          maxWidth: { xs: '100%', sm: '80%', md: '80%' },
        }}
      >
        <Grid container spacing={2}>
          {viagens.map((viagem, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                style={{
                  marginBottom: '10px',
                  border: '1px solid black', // Borda preta
                  color: 'black', // Fonte preta
                  borderRadius: '10px',
                  fontFamily: 'sans-serif',
                  textDecoration: 'none',
                  backgroundColor: 'transparent', // Sem background color
                }}
              >
                <CardContent>
                  <Typography variant="body2" gutterBottom>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span>Veículo: {viagem.placa}</span>
                      <span>{viagem.carreta}</span>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span>{viagem.nome.split(' ')[0]}</span>
                    </div>
                  </Typography>
                  <Divider
                    style={{
                      backgroundColor: 'black',
                      borderRadius: '10px',
                      marginBottom: '10px',
                    }}
                  />
                  {[
                    { label: 'Receitas (R$)', value: viagem.total_receitas },
                    {
                      label: 'Diesel (R$)',
                      value: viagem.total_combustivel,
                    },
                    { label: 'Arla (R$)', value: viagem.total_arla },
                    { label: 'Comissão (R$)', value: viagem.total_comissao },
                    { label: 'Descarga (R$)', value: viagem.total_descarga },
                    {
                      label: 'Outras Despesas (R$)',
                      value: `${viagem.total_outros}`,
                    },
                    {
                      label: 'Total Despesas Variáveis (R$)',
                      value: viagem.total_despesas,
                    },
                    {
                      label: 'Resultado Líquido (R$)',
                      value: viagem.lucro,
                    },
                    {
                      label: 'Resultado Líquido (%)',
                      value: viagem.lucro_bruto,
                    },
                    {
                      label: 'Consumo/Receita (R$)',
                      value: viagem.consumo_receita,
                    },
                    {
                      label: 'Despesa/Receita (R$)',
                      value: viagem.despesa_receita,
                    },
                  ].map((item, idx) => (
                    <Typography key={idx} variant="body2">
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <span>{item.label}:</span>
                        <span>{NumberFormat(item.value)}</span>
                      </div>
                    </Typography>
                  ))}
                </CardContent>
              </Card>
            </Grid>
          ))}
          {viagens.length > 0 && (
            <Grid item xs={12} sm={6} md={4}>
              <Card
                style={{
                  marginBottom: '10px',
                  border: '1px solid black', // Borda preta
                  color: 'black', // Fonte preta
                  borderRadius: '10px',
                  fontFamily: 'sans-serif',
                  textDecoration: 'none',
                  backgroundColor: 'transparent', // Sem background color
                }}
              >
                <CardContent>
                  <Typography variant="body2" gutterBottom>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span>Totalizador</span>
                    </div>
                  </Typography>
                  <Divider
                    style={{
                      backgroundColor: 'black',
                      borderRadius: '10px',
                      marginBottom: '10px',
                    }}
                  />
                  {[
                    { label: 'Receitas (R$)', value: totalizador.receitas },
                    { label: 'Comissão (R$)', value: totalizador.comissao },
                    {
                      label: 'Resultado Líquido(R$)',
                      value: totalizador.lucro,
                    },
                    {
                      label: 'Resultado Líquido (%)',
                      value: `${totalizador.lucrobruto}`,
                    },
                  ].map((item, idx) => (
                    <Typography key={idx} variant="body2">
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <span>{item.label}:</span>
                        <span>{NumberFormat(item.value)}</span>
                      </div>
                    </Typography>
                  ))}
                </CardContent>
              </Card>
            </Grid>
          )}
        </Grid>
      </Box>
      {viagens.length > 0 && (
        <PDFDownloadLink
          document={
            <PDFContent
              viagens={viagens}
              dtinicial={dtinicial}
              dtfinal={dtfinal}
              totalizador={totalizador}
            />
          }
          fileName="DRE.pdf"
          style={{
            textDecoration: 'none',
            padding: '10px',
            color: '#4a4a4a',
            backgroundColor: '#f2f2f2',
            border: '1px solid #4a4a4a',
            borderRadius: '4px',
            marginTop: '20px',
          }}
        >
          {({ blob, url, loading, error }) =>
            loading ? 'Carregando documento...' : 'Baixar PDF'
          }
        </PDFDownloadLink>
      )}
    </ContainerPainel>
  );
}
